module.exports = __webpack_public_path__ + "img/30.3f318835.jpg";